function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Move-in Date");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Move-in Date");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Regular/Truck",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(2.000000, 3.000000)",
  stroke: "#80A1FE",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 2.47727273,
  cy: 9.47727273,
  r: 1.47727273
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 10.4772727,
  cy: 9.47727273,
  r: 1.47727273
}), /*#__PURE__*/React.createElement("g", {
  id: "truck"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-path",
  x: 0,
  y: 0,
  width: 8.86363636,
  height: 7.68181818
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Shape",
  points: "9 3 11.3636364 3 13.1363636 4.77272727 13.1363636 7.72727273 9 7.72727273"
}))));

var SvgTransport = function SvgTransport(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTransport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/transport.eba1aa06.svg";
export { ForwardRef as ReactComponent };